import React, {useCallback, useEffect} from 'react';
import {Link, NavLink, useLocation,useHistory} from 'react-router-dom';
import {Avatar} from 'components/Avatar'
import {request} from 'helpers/tools';
import styles from 'css_modules/Nav.module.css';
import logo from 'assets/svg/docspoint.svg';
import upload from 'assets/svg/2_file_upload.svg';
import docs from 'assets/svg/2_documents.svg';
import my_docs from 'assets/svg/2_my_documents.svg';
import archive from 'assets/svg/2_archive.svg';
import templates from 'assets/svg/2_templates.svg';
import stats1 from 'assets/svg/2_stats1.svg';
import stats2 from 'assets/svg/2_stats2.svg';
import {Button} from 'components/Button';
import {NavSelect} from 'components/NavSelect';

export const Nav = ({fetchUser, permissions, user, closeMobileNav}) => {
    let location = useLocation();
    const history = useHistory();

    const userFullName = `${user.first_name} ${user.last_name}`;

    const logout = useCallback(async () => {
        await request('/rest-auth/logout/', 'POST', null, true);
        localStorage.removeItem('DocspointJWT');
        window.location.href = '/auth/login';
    }, []);

    useEffect(() => { 
        const handleTokenChange = e => {
            if (e.key === 'DocspointJWT') {
                if (e.newValue) {
                    fetchUser();
                } else {
                    logout();
                }
            }
        }
        window.addEventListener('storage', handleTokenChange)
        return () => window.removeEventListener('storage', handleTokenChange)
    }, [fetchUser, logout])
    
    let onRoleChange = async (e) => {
        let role = user.roles[parseInt(e.target.id.substring(1))];
        if (role==="managementuser"){
            const str = e.target.id
            const matches = str.match(/\d+/g);
            role+=  matches && matches[1] ? parseInt(matches[1], 10) : '';
        }
        await request('/user/role/', 'POST', role).catch(err => console.log(err));
        fetchUser();
    }
    const localize = (role)=>{
        switch (role){
            case 'clientuser':
                return 'Základní uživatel'
            case 'accountantuser':
                return 'Účetní uživatel'
            case 'maintenanceuser':
                return 'Obslužný uživatel'
            case 'managementuser':
                return 'Schvalovací uživatel'
            case 'organizationunitadmin':
                return 'Admin uživatel  '
            default:
                return 'Neznama roli'
        }
    }
    
    let prettifyRole = (role) => {return localize(role);}
    
    if (user.role.toLowerCase() !== "organizationunitadmin" && location.pathname.endsWith('stats') ){
        history.push('/archive');
    }

    const populateRoleChoices = () => {
        if (user.roles.length === 1 && user.current_management_level === null) return null;

        const options = user.roles.flatMap((role, i) => {
            if (role.toLowerCase() === "managementuser" && user.management_levels) {
                return user.management_levels.map(level => ({
                    id: `m${i}_${level}`,
                    value: `${role}|${level}`,
                    title: `${prettifyRole(role)} (ú.${level})`,
                }));
            } else {
                return [{
                    id: `r${i}`,
                    value: role,
                    title: prettifyRole(role),
                }];
            }
        });

        const selectedOption = options.find(opt => {
            const parts = opt.value.split('|');
            if (parts.length === 2) {
                return (
                    user.role.toLowerCase() === parts[0] &&
                    String(user.current_management_level) === parts[1]
                );
            }
            return user.role.toLowerCase() === parts[0];
        });

        const handleSelectChange = (event) => {
            const selected = options.find(opt => opt.id === event.target.value);
            if (!selected) return;

            onRoleChange({
                target: {
                    value: selected.value,
                    id: selected.id
                }
            });
        };

        return (
            <div className={styles.navRoleSelect__wrapper}>
                <NavSelect
                    name="navRole"
                    data={options.map(({ id, title }) => ({ id, title }))}
                    value={selectedOption?.id}
                    onChange={handleSelectChange}
                    notNull={true}
                    direction="up" 
                    nav
                />
            </div>
        );
    };

    const navToUpload = (e) => {
        if (String(sessionStorage.getItem("template"))!=='undefined'){
            sessionStorage.setItem("template",undefined)
        }
        history.push('/upload');
    }
    const navToMyTemplates = (e) =>{
        if(location.pathname.endsWith('my_templates') ) {
            e.preventDefault()
            console.log('denied to mytemplates')
        }
    } 
    const navToStats= (e) =>{
        if(location.pathname.endsWith('stats') ) {
            e.preventDefault()
            console.log('denied to stats')
        }
    } 
    const navToStatsUsers= (e) =>{
        if(location.pathname.endsWith('statsusers') ) {
            e.preventDefault()
            console.log('denied to stats users')
        }
    } 
    const navToMyDocuments = (e) =>{
        if(location.pathname.endsWith('my_documents') ) {
            e.preventDefault()
            console.log('denied to mydocs')
        }
    } 
    const navToDocuments = (e) =>{
        if( !location.pathname.endsWith('my_documents') && location.pathname.endsWith('documents') ){
            e.preventDefault()
            console.log('denied to docs')
        } 
    } 
    const navToArchive = (e) =>{
        if( location.pathname.endsWith('archive') ){
            e.preventDefault()
            console.log('denied to arch')
        } 
    } 
    
    const handleNavClick = (e) => {
        if (e.target.closest(`.${styles.navRoleSelect__wrapper}`)) {
            return;
        }

        if (e.target.closest('a') || e.target.closest('button')) {
            if (closeMobileNav) {
                closeMobileNav();
            }
        }
    };

    return (
        <nav className={styles.container} onClick={handleNavClick}>
            <div className={styles.sticky}>
                <section className={styles.top}>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img src={logo} alt="logo" style={{ width: "80%" }} />
                    </div>
                 
                    <div className={styles.menu}>
                        {
                            permissions.upload &&
                            <NavLink to="/upload" onClick={navToUpload } activeClassName={styles.menuItemActive} className={styles.menuItem}>
                             <img src={upload}className={styles.menuIcon} alt="" />
                                Nahrát
                            </NavLink>
                        }
                        {
                            permissions.accessDocuments && (
                                <NavLink
                                    to="/documents"
                                    activeClassName={styles.menuItemActive}
                                    className={styles.menuItem}
                                    onClick={navToDocuments}
                                >
                                 <img src={docs}className={styles.menuIcon} alt=""/>
                                    Doklady
                                </NavLink>
                            )}
                        {
                            permissions.accessMyDocuments && (
                                <NavLink    to="/my_documents" activeClassName={styles.menuItemActive} 
                                            className={styles.menuItem} onClick={navToMyDocuments}>
                                 <img src={my_docs}className={styles.menuIcon} alt=""/>
                                    Moje doklady
                                </NavLink>
                            )
                        }
                        {
                            permissions.accessArchive &&
                            <NavLink to="/archive" activeClassName={styles.menuItemActive} 
                                      onClick={navToArchive}  className={styles.menuItem}>
                               <img src={archive}className={styles.menuIcon} alt=""/>
                                Archiv
                            </NavLink>
                        }
                        {
                            user.toggle_document_templates===true &&
                            <NavLink to="/my_templates" activeClassName={styles.menuItemActive} 
                                      onClick={navToMyTemplates}  className={styles.menuItem}>
                              <img src={templates}className={styles.menuIcon} alt=""/>
                                Šablony
                            </NavLink>
                        }
                        { user["role"]==="OrganizationUnitAdmin" &&
                            <NavLink to="/stats" activeClassName={styles.menuItemActive} 
                                      onClick={navToStats}  className={styles.menuItem}>
                                <img src={stats1}className={styles.menuIcon} alt=""/>
                                Statistiky Společnosti
                            </NavLink>
                        }
                        { (user["role"]==="OrganizationUnitAdmin"&& user.can_see_user_stats ) &&
                            <NavLink to="/statsusers" activeClassName={styles.menuItemActive} 
                                      onClick={navToStatsUsers}  className={styles.menuItem}>
                                <img src={stats2}className={styles.menuIcon} alt=""/>
                                Statistiky Uživatelů
                            </NavLink>
                        }
                    </div>
                    
                    <div className={styles.button}></div>
                </section> 
                
                <section className={styles.bottom}>
                    <div className={styles.linkList}>
                        <div>
                            <a href="https://www.youtube.com/playlist?list=PLieL8NZ8IhuVwlDNcMPEuMtZs79dCoYmS" target="_blank" rel="noreferrer">
                                Videonávody
                            </a>
                        </div>
                        <div>
                            <a href="https://docspoint.cz/cs/faq-nejcastejsi-dotazy-navody/" target="_blank" rel="noreferrer" title={`Verze aplikace: ${process.env.REACT_APP_GIT_HASH || '123abc'}`}>
                                Často kladené dotazy (FAQ)
                            </a>
                        </div>
                        <div>
                            <a href="mailto:servis@docspoint.cz">Kontakt</a>
                        </div>
                    </div>

                    <div className={styles.avatar}>
                        <Link to="/profile">
                            <Avatar user={user}/>
                        </Link>
                    </div>
                    
                    <div className={styles.userContainer}>
                        <NavLink to="/profile" activeClassName={styles.menuItemActive} className={styles.userFullName}>
                            {userFullName}
                        </NavLink>
                        <Link to="/profile" className={styles.userCompany}>{user.company_title}</Link>
                    </div>
                    
                    <div className={styles.radioContainer}> 
                        {populateRoleChoices()} 
                    </div>
                    
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', paddingBottom: "1rem", paddingTop: "1rem" }}>
                        <Button onClick={logout} className={styles.logOut}>
                            Odhlásit se
                        </Button>
                    </div>
                </section>
            </div>
        </nav>
    )
};